import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-order-processing',
  templateUrl: './order-processing.component.html',
  styleUrls: ['./order-processing.component.css']
})
export class OrderProcessingComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
